var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#867659",
    clipPath: "url(#instagram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.878 24.462c.337-1.382 1.988-.978 1.785.202v.002c-2.123 8.728-9.976 15.2-19.312 15.2C9.398 39.866.5 30.967.5 20.013S9.398.163 20.351.163c9.37 0 17.223 6.504 19.313 15.2.169 1.314-1.55 1.348-1.787.202-1.955-7.82-9.066-13.616-17.492-13.616-9.975 0-18.064 8.089-18.064 18.064 0 9.976 8.088 18.065 18.064 18.065 8.427 0 15.504-5.797 17.492-13.616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.416 19.372.004-.006a1.11 1.11 0 0 0 .223 1.525c.173.143.41.234.683.234a1.112 1.112 0 0 0 .604-2.047 1.07 1.07 0 0 0-.604-.178c-.405 0-.742.203-.91.472"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.734 12.9h8.73c1.516 0 2.763 1.214 2.763 2.731v8.763a2.776 2.776 0 0 1-2.764 2.763h-8.729a2.776 2.776 0 0 1-2.764-2.763v-8.73a2.776 2.776 0 0 1 2.764-2.763m9.841 1.619h-.303l-2.09-.034v2.427h2.393zm-5.494 3c-.842 0-1.55.403-2.022 1.044-.27.404-.472.91-.472 1.449a2.49 2.49 0 0 0 2.494 2.494 2.49 2.49 0 0 0 2.495-2.494c0-.54-.17-1.045-.473-1.45a2.43 2.43 0 0 0-2.022-1.044m4.416 8.223c.741 0 1.347-.607 1.347-1.348l.001-5.831h-2.123c.202.437.303.943.303 1.449a3.914 3.914 0 0 1-3.91 3.91 3.913 3.913 0 0 1-3.909-3.91c0-.506.135-1.011.303-1.45h-2.123v5.832c0 .741.607 1.348 1.348 1.348z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "instagram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h40v40H.5z"
  })))));
};
export default SvgInstagram;